export default function slugFromString(str) {
  if (!str) return str
  let string = str

  string = string.replace(/^\s+|\s+$/g, "") // trim
  string = string.toLowerCase()

  // remove accents, swap ñ for n, etc
  const from = "ãàáäâďẽèéëêěìíïîõòóöôùúüûůñňçšťčřžý·/_,:;"
  const to = "aaaaadeeeeeeiiiiooooouuuuunncstcrzy--------"
  for (let i = 0, l = from.length; i < l; i++) {
    string = string.replace(new RegExp(from.charAt(i), "g"), to.charAt(i))
  }

  // Strip parenthesis: Brno (Czech Republic)
  string = string.replace("(", "")
  string = string.replace(")", "")
  string = string.replace("?", "")

  string = string
    .replace(/\s+/g, "-") // collapse whitespace and replace by -
    .replace(/-+/g, "-") // collapse dashes

  return string
}
